import { render, staticRenderFns } from "./afm-form.vue?vue&type=template&id=8d6cbb1c&scoped=true&"
import script from "./afm-form.vue?vue&type=script&lang=js&"
export * from "./afm-form.vue?vue&type=script&lang=js&"
import style0 from "./afm-form.vue?vue&type=style&index=0&id=8d6cbb1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6cbb1c",
  null
  
)

export default component.exports